/**
 * Vuex module for the search component
 */
import debug from 'debug'

const dbg = debug('store:action:search:')

const actions = {
  init ({ commit }, placeholder) {
    dbg('Open search form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('INIT', placeholder)
  },
  close ({ commit }) {
    dbg('Close search form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE')
  },
  setSearchText ({ commit }, searchText) {
    commit('SET_SEARCH', searchText)
  }
}

const mutations = {
  INIT (state, placeholder) {
    state.placeholder = placeholder
    state.visible = true
  },

  CLOSE (state) {
    state.visible = false
    state.placeholder = ''
  },

  SET_SEARCH (state, searchText) {
    state.searchText = searchText
  }
}

const state = {
  visible: false,
  placeholder: '',
  searchText: ''
}

const getters = {
  visible: state => state.visible,
  placeholder: state => state.placeholder,
  searchText: state => state.searchText
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
